/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Data payload for \'appointment.sync_started\' notifications.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentSyncStartedData { 
    appointmentId: number;
    isSyncing: boolean;
}
export const AppointmentSyncStartedData_appointmentId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncStartedData_isSyncing_Validators: ValidatorFn[] =
    [  Validators.required, ];


